<template>
    <Button-group>
        <Button v-for="btn in btns" :key="btn.key" :class="{'ivu-btn-primary':btn.order!=0}" @click="sort(btn.key)"
                class="sortBtn">
      <span v-if="btn.order==0">
        <Icon type="md-arrow-dropup" style="margin-top:3px;"></Icon>
        <Icon type="md-arrow-dropdown" style="margin-top:10px;"></Icon>
        <span style="padding-left:15px;">{{btn.value}}</span>
      </span>
            <span v-if="btn.order==1">
        <Icon type="md-arrow-dropup" style="margin-top:3px;"></Icon>
        <span style="padding-left:15px;">{{btn.value}}</span>
      </span>
            <span v-if="btn.order==2">
        <Icon type="md-arrow-dropdown" style="margin-top:10px;"></Icon>
        <span style="padding-left:15px;">{{btn.value}}</span>
      </span>
        </Button>
    </Button-group>
</template>
<script>
export default {
    name: 'sortButtonGroup',
    props: {
        buttons: { type: Array },
    },
    data() {
        return {
            btns: [{ key: '0', value: 'as', order: 0 }],
        };
    },
    methods: {
        // 0是未选择，1是升序，2是降序
        sort(btnKey) {
            let btn;
            for (let index = 0; index < this.btns.length; index++) {
                if (this.btns[index].key == btnKey) {
                    btn = this.btns[index];
                    this.$set(this.btns[index], 'order', btn.order >= 2 ? 0 : btn.order + 1);
                } else {
                    this.$set(this.btns[index], 'order', 0);
                }
            }
            this.$emit('on-order', btn);
        },
    },
    mounted() {
        for (let index = 0; index < this.buttons.length; index++) {
            const element = this.buttons[index];
            element.order = 0;
            this.$set(this.btns, index, element);
        }
    },
};
</script>
<style lang="less" scoped>
.sortBtn {
    i {
        line-height: 6px;
        position: absolute;
    }
}
</style>
